module.exports = __webpack_public_path__ + "img/step3.f7e1537e.jpg";